module.exports = __webpack_public_path__ + "static/media/ic_left.c6604006.png";